import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { site, telLink, mailLink, waLink } from "@/config/site";
import { services } from "@/data/content";

const quickLinks = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Industries", href: "#industries" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export function Footer() {
  return (
    <footer className="bg-navy-dark text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 md:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        {/* Brand */}
        <div>
          <img src="/logo-white.png" alt="BNZ Solutions — Office Branding, Signage & Printing" className="h-12 w-auto" width="192" height="105" loading="lazy" />
          <p className="mt-4 text-sm leading-relaxed text-white/60">
            {site.positioning}. Premium office branding, signage &amp; commercial printing across Bengaluru &amp; Karnataka.
          </p>
          <div className="mt-6 flex gap-3">
            <a href={site.socials.instagram} aria-label="Instagram" className="flex h-9 w-9 items-center justify-center border border-white/15 transition-colors hover:border-gold hover:text-gold"><Instagram className="h-4 w-4" /></a>
            <a href={site.socials.facebook} aria-label="Facebook" className="flex h-9 w-9 items-center justify-center border border-white/15 transition-colors hover:border-gold hover:text-gold"><Facebook className="h-4 w-4" /></a>
            <a href={site.socials.linkedin} aria-label="LinkedIn" className="flex h-9 w-9 items-center justify-center border border-white/15 transition-colors hover:border-gold hover:text-gold"><Linkedin className="h-4 w-4" /></a>
          </div>
        </div>

        {/* Quick links */}
        <div>
          <h4 className="font-heading text-lg text-white">Explore</h4>
          <div className="gold-rule my-4" />
          <ul className="space-y-3">
            {quickLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-white/60 transition-colors hover:text-gold">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-heading text-lg text-white">Services</h4>
          <div className="gold-rule my-4" />
          <ul className="grid grid-cols-1 gap-2">
            {services.slice(0, 8).map((s) => (
              <li key={s.title}>
                <a href="#services" className="text-sm text-white/60 transition-colors hover:text-gold">{s.title}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-lg text-white">Get in Touch</h4>
          <div className="gold-rule my-4" />
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              <span>{site.address.city}, {site.address.state}, {site.address.country}</span>
            </li>
            <li>
              <a href={telLink} className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-call">
                <Phone className="h-4 w-4 text-gold" /> {site.phone}
              </a>
            </li>
            <li>
              <a href={mailLink()} className="flex items-center gap-3 transition-colors hover:text-gold" data-testid="footer-email">
                <Mail className="h-4 w-4 text-gold" /> {site.email}
              </a>
            </li>
            <li>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" className="mt-2 inline-flex items-center bg-gold px-4 py-2 text-sm font-semibold text-navy transition-colors hover:bg-gold-light" data-testid="footer-whatsapp">
                Chat on WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} BNZ Solutions. All rights reserved.</p>
          <p>Office Branding · Signage · Commercial Printing — Bengaluru, Karnataka</p>
        </div>
      </div>
    </footer>
  );
}
